<template>
  <div class="direct-user-banner">
    <img src="../../../assets/images/direct-user-banner.png">
  </div>
</template>

<script>
export default {
  name: 'DirectUserBanner'
}
</script>

<style scoped lang="stylus">
  .direct-user-banner
    width: 100%
    padding-bottom: 121px
    img
      width: 100%
</style>



// WEBPACK FOOTER //
// src/pages/advantage/components/DirectUserBanner.vue